import { render, staticRenderFns } from "./GestantesPuerperas.vue?vue&type=template&id=64cc44b1"
import script from "./GestantesPuerperas.vue?vue&type=script&lang=js"
export * from "./GestantesPuerperas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports